import React from "react";
import {
  Box,
  Button,
  Container,
  HStack,
  Icon,
  IconButton,
  VStack,
} from "@chakra-ui/react";
import BearSelectorContainer from "components/BearSelectorContainer";
import BearStatsContainer from "components/BearStatsContainer";
import FancyBearImage from "components/FancyBearImage";
import { Link } from "react-router-dom";
import { FaChevronLeft, FaExternalLinkAlt } from "react-icons/fa";
import BearStakedTraitsContainer from "components/BearStakedTraitsContainer";
import BearProvider from "providers/BearProvider";
import BearContext from "contexts/BearContext";
import BearAttributesContainer from "components/BearAttributesContainer";
import BearLevelContainer from "components/BearLevelContainer";
import { fancyBearsContract, openSeaAssetBaseUrl } from "config";

const BearDetailsPage = () => (
  <BearProvider>
    <Container pt="12" pb="16">
      <VStack spacing="3" align="flex-start">
        <HStack
          spacing={{
            base: "0",
            sm: "2",
          }}
          w="full"
        >
          <Link to="/bears">
            <IconButton
              ml="-3"
              icon={<Icon as={FaChevronLeft} w="6" h="auto" />}
              variant="link"
              aria-label=""
              size="sm"
            />
          </Link>

          <BearSelectorContainer basePath="/bears" />
        </HStack>

        <Box w="full">
          <VStack spacing="3" w="full" p="3" bg="bright.500">
            <BearContext.Consumer>
              {({ tokenId }) => (
                <>
                  <HStack
                    justify="space-between"
                    w="full"
                    spacing={{
                      base: "0",
                      sm: "8",
                    }}
                  >
                    <BearLevelContainer />

                    <Button
                      as="a"
                      href={`${openSeaAssetBaseUrl}/${fancyBearsContract.address}/${tokenId}`}
                      target="_blank"
                      rel="noreferrer"
                      flexShrink="0"
                      size="sm"
                      cursor="pointer"
                      colorScheme="dark"
                      variant="outline"
                      rightIcon={<Icon as={FaExternalLinkAlt} />}
                    >
                      OpenSea
                    </Button>
                  </HStack>

                  <FancyBearImage tokenId={tokenId!} size="1024" />
                </>
              )}
            </BearContext.Consumer>
            <BearStatsContainer />
          </VStack>
          <BearAttributesContainer />
        </Box>

        <BearStakedTraitsContainer />
      </VStack>
    </Container>
  </BearProvider>
);

export default BearDetailsPage;
